import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import Select, { components } from 'react-select'
import { Pending } from './helperComponents'
import FileInput from './FileInput'
import DropdownActions from './DropdownActions'
import { postRequest } from '../../services/base'
import { NavContext } from '../../context/global_context'
import { UploadContext } from '../../context/upload_file_context'

const { Option } = components
const FileOption = (props) => (
  <Option {...props}>
    <div className="flex flex-col">
      {props.data?.id && <div>id: {props.data.id}</div>}
      <div>{props.data.label}</div>
      {props.data.importedBy ? (
        <div className="pt-1">{props.data.importedBy}</div>
      ) : (
        ''
      )}
    </div>
  </Option>
)
const FileActions = ({
  formRef,
  filesList,
  fileType,
  fileName,
  is_uploading,
  reloadData,
  resetStations,
}) => {
  const [navValue, dispatch] = useContext(NavContext)
  const [uploadState, setUploadState] = useContext(UploadContext)
  const downloadUrl = ''
  const loadingFile = ''

  const importVersions = [
    { value: 'all', label: 'Current State' },
    ...filesList
      .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
      .map((f) => ({
        value: f,
        label: f.created_at,
        id: f.id,
        importedBy: f.user.email,
        errors: f.error_reason,
      })),
  ]

  const buildFormData = (form, formData, attrs) => {
    dispatch({
      type: 'loader',
      data: {
        caption: 'File upload is in progress',
        showLoader: true,
      },
      notification: {},
    })
    const { name, files } = form.target
    if (attrs?.svg_side) {
      formData.append('files', files[0], `${name}.zip`)
    } else {
      formData.append('files', files[0], `${name}.csv`)
    }
    formData.append('file_type', name)
    formData.append('vehicle_id', navValue?.id)
    Object.entries(attrs).forEach(([key, val]) => {
      formData.append(`${key}`, val)
    })
    return formData
  }

  const uploadFile = (evt, attrs = {}) => {
    evt.preventDefault()

    const form = formRef.current
    const formData = new FormData(form)
    buildFormData(evt, formData, attrs)
    processUplaodedFile(formData)
  }

  const processUplaodedFile = async (data) => {
    let res = await postRequest(`/api/importer/upload/`, data)
    if (res?.error_code) {
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: res?.msg,
          loader: true,
        },
      })
    } else {
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: 'File Successfully uploaded into system and we are processing it.',
          loader: true,
        },
      })
    }

    setUploadState({})
    reloadData()
  }

  const disabledImports = [
    'connectorlist',
    'devices',
    'category_connector',
    'componentalias',
  ]
  const labelForSelect = () => {
    if (uploadState?.file_type != fileType) {
      return 'Select version'
    } else if (
      uploadState?.selected_version?.value === 'all' &&
      uploadState?.file_type == fileType
    ) {
      return 'Current State'
    } else if (
      uploadState?.selected_version?.value ===
        'current_state_inlcude_not_constrained' &&
      uploadState?.file_type == fileType
    ) {
      return 'Current State (Include Not Constrained)'
    } else if (
      uploadState?.selected_version?.value ===
        'current_state_include_part_number' &&
      uploadState?.file_type == fileType
    ) {
      return 'Current State (Include Part Number)'
    } else if (uploadState?.file_type == fileType) {
      return `id: ${uploadState?.selected_version.id}:: ${uploadState?.selected_version.label}`
    }
  }

  return (
    <>
      {is_uploading ? (
        <div className="ml-2" style={{ minWidth: '150px' }}>
          {is_uploading ? (
            <span className="uploader-loader"></span>
          ) : (
            <Pending />
          )}
        </div>
      ) : (
        <div
          className={`relative flex flex-row justify-end items-center font-light ${loadingFile && 'hidden'}`}
        >
          {fileType === 'connector_layout' ? (
            <>
              <span className="mr-4">
                <FileInput
                  labelTitle={'Import Connector Side'}
                  fileFieldName={fileType}
                  fileFieldId={'connector-layout-connector-side'}
                  onChange={(e) => uploadFile(e, { svg_side: 'connector' })}
                />
              </span>
              <FileInput
                labelTitle={'Import Terminal Side'}
                fileFieldName={fileType}
                fileFieldId={'connector-layout-terminal-side'}
                onChange={(e) => uploadFile(e, { svg_side: 'terminal' })}
              />
            </>
          ) : fileType === 'stations' ? (
            <>
              <span
                className="cursor-pointer underline text-red-500 mr-4"
                onClick={() => {
                  resetStations()
                }}
              >
                Reset
              </span>
              <FileInput
                labelTitle={'Import'}
                fileFieldName={fileType}
                fileFieldId={fileType}
                onChange={uploadFile}
                isDisabled={disabledImports.includes(fileType)}
              />
            </>
          ) : (
            <FileInput
              labelTitle={'Import'}
              fileFieldName={fileType}
              fileFieldId={fileType}
              onChange={uploadFile}
              isDisabled={disabledImports.includes(fileType)}
            />
          )}
          <div className="ml-2" style={{ minWidth: '250px' }}>
            <Select
              inputName={'blank'}
              isMulti={false}
              value={{ label: labelForSelect() }}
              options={
                fileType == 'sales_code_constraints'
                  ? [
                      {
                        value: 'current_state_inlcude_not_constrained',
                        label: 'Current State (Include Not Constrained)',
                      },
                      ...importVersions,
                    ]
                  : fileType == 'connector_layout'
                    ? [
                        {
                          value: 'current_state_include_part_number',
                          label: 'Current State (Include Part Number)',
                        },
                        ...importVersions,
                      ]
                    : importVersions
              }
              placeholder="Select version"
              className="w-full"
              onChange={(choice) => {
                setUploadState({
                  type: 'version',
                  data: choice,
                  file_type: fileType,
                  file_name: fileName,
                })
              }}
              components={{ Option: FileOption }}
            />
          </div>
          <DropdownActions
            fileType={fileType}
            downloadUrl={`${downloadUrl}/${fileName}`}
            uploadState={uploadState}
            reloadData={reloadData}
          />
        </div>
      )}
    </>
  )
}

FileActions.propTypes = {
  filesList: PropTypes.array,
  formRef: PropTypes.object.isRequired,
  fileType: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
  is_uploading: PropTypes.bool.isRequired,
  reloadData: PropTypes.func.isRequired,
}

export default FileActions
